let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("arhgZ"), load("dvM2p")]).then(() => parcelRequire('gXgjG'));